<template>

  <div>
    <data-table
    table-ref="rentalduetable"

    url="/report/property/due"
    :fields="fields"

    title="Tenancy Due"
    icon="fa fa-asterisk"

    search-placeholder="Site name, Landlord..."
     />

    <events-calendar category="tenancy" />

</div>
</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import EventsCalendar from '@/components/atoms/EventsCalendar'

export default {
  mixins: [DateMixins, NumberMixins],

  components: {
    EventsCalendar
  },

  props: {
    orgId: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      stats: this.getStats(),
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'status',
          title: 'Status',
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-primary'
        },
        {
          name: 'landowner',
          title: 'Landlord',
          visible: this.isTowerCo()
        },
        {
          name: 'siteName',
          title: 'Site Name'
        },
        {
          name: 'years',
          title: 'Years',
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'term',
          title: 'Term',
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          callback: this.formatDate,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'nextPaymentDate',
          title: 'Date Due',
          callback: this.formatDate,
          titleClass: 'text-danger',
          dataClass: 'text-danger text-right'
        },
        {
          name: 'nextPayment',
          title: 'Due',
          callback: this.formatMoney,
          titleClass: 'text-danger',
          dataClass: 'text-danger text-right'
        },
        {
          name: 'paid',
          title: 'Paid',
          callback: this.formatMoney,
          titleClass: 'hidden-sm-and-down text-success',
          dataClass: 'hidden-sm-and-down text-success text-right'
        },
        {
          name: 'outstanding',
          title: 'O/S',
          callback: this.formatMoney,
          titleClass: 'hidden-xs-only text-warning',
          dataClass: 'hidden-xs-only text-warning text-right'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// TenancyDue.vue?254d6a15